import { render, staticRenderFns } from "./UserReviewCard.vue?vue&type=template&id=b9f312e4"
import script from "./UserReviewCard.vue?vue&type=script&lang=js"
export * from "./UserReviewCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports